export default {
  /** ---------接口配置模块--------- */
  // 获取环境列表
  getEnvironmentList: '/gateway/api/environment/get/',
  // 获取RPC方法名
  getRPCServerName: '/gateway/api/tools/method/get/',
  // 获取IDL信息
  getEnvironmentDetail: '/gateway/api/environment/read/',
  // 更新IDL信息
  updateIDLInfo: '/gateway/api/environment/update/',
  // 根据分支名获取idl信息
  getBranchIDLInfo: '/gateway/api/tools/idl/get/',
  // 获取接口列表
  getInterfaceList: '/gateway/api/interface/get/',
  // 获取接口详情
  getInterfaceDetail: '/gateway/api/interface/read/',
  // 接口跨服务迁移
  interfaceMigrate: '/gateway/api/interface/transfer/',
  // 获取某个配置上一次完整发布(即不包含灰度配置的发布)
  getLastFullRelease: '/gateway/api/interface/last_full_release/',
  // 代码模式获取接口详情
  getNewInterfaceDetail: '/gateway/api/interface/new_read/',
  // 新增接口
  createInterface: '/gateway/api/interface/create/',
  // 更新接口
  updateInterface: '/gateway/api/interface/update/',
  // 新的更新接口
  updateInterfaceNew: '/gateway/api/interface/new_update/',
  // 上线
  onlineInterface: '/gateway/api/interface/online/',
  // 接口下线
  offlineInterface: '/gateway/api/interface/offline/',
  // 接口删除
  deleteInterface: '/gateway/api/interface/delete/',
  // 获取接口diff 差异
  getInterfaceDiffInfo: '/gateway/api/release/diff/',
  // 审核接口上线
  release: '/gateway/api/release/create/',
  // 获取service信息
  getServiceInfo: '/gateway/api/service/get/',
  // 撤销上线审核
  revokeAudit: '/gateway/api/release/cancel/',
  // 创建接口场景标签
  updateInterfaceLabel: '/gateway/api/interface/scene_label/update/',
  // 删除接口场景标签
  deleteInterfaceLable: '/gateway/api/interface/scene_label/delete/',
  // 获取接口场景标签
  // getInterfaceLabel: '/gateway/api/interface/scene_label/get/',
  // 表单模式 和 代码模式转化
  transferCodeModel: '/gateway/api/interface/new_update_convert/',
  transferFormModel: '/gateway/api/interface/update_convert/',
  // 获取自定义插件列表
  getCustomerPlugin: '/gateway/api/tools/custom_plugin/get/',
  // 获取自定义函数插件列表
  getPlugins: '/gateway/api/custom_plugin/get/',
  // 获取自定义函数插件列表
  getPluginModel: '/gateway/api/static/model_get/',
  // 自定义函数插件校验
  pluginDebugger: '/gateway/api/custom_plugin/debug/',
  // 常用函数插件校验
  funcPluginDebugger: '/gateway/api/tools/params_function/debug/ ',
  // 常用函数库
  getFuncPluginLib: '/gateway/api/tools/params_function/get/ ',
  /** service模块 */
  // 接口复制
  copyInterface: '/config/interface/copy/',
  /** ---------service模块--------- */
  // 获取服务列表
  getServiceList: '/gateway/api/service/get/',
  // 删除服务分组
  deleteGroup: '/gateway/api/service/delete/',
  // 新建分组
  createGroup: '/gateway/api/service/create/',
  // 编辑分组
  editGroup: '/gateway/api/service/update/',
  // 获取成员列表
  getMemberList: '/gateway/api/member/get/',
  // 添加分组成员
  addMember: '/gateway/api/member/add/',
  // 编辑分组成员
  editMember: '/gateway/api/member/update/',
  deleteMember: '/gateway/api/member/delete/',
  // 全局搜索功能
  searchGlobal: '/gateway/api/interface/search/',
  // 获取业务线列表
  getBusinessList: '/gateway/api/tools/business/get/',
  /** ---------公共模块--------- */
  queryPsm: '/gateway/api/tools/psm/suggest/',
  /** ---------团队信息--------- */
  getTeamMember: '/gateway/api/team/member/get/',
  getTeamRole: '/gateway/api/team/role/get/',
  addTeamMember: '/gateway/api/team/member/add/',
  updateTeamMember: '/gateway/api/team/member/update/',
  deleteTeamMember: '/gateway/api/team/member/delete/',

  // 枚举包管理
  createEnumPackage: '/gateway/api/enum_package/create/',
  getEnumPackage: '/gateway/api/enum_package/get/',
  updateEnumPackage: '/gateway/api/enum_package/update/',
  deleteEnumPackage: '/gateway/api/enum_package/delete/',
  updateInterfaceWhenEnumExpired: '/gateway/api/enum_package/interface/update/',
  getInterfaceBindingEnumPackage: '/gateway/api/interface/enum_package/get/', // 获取接口绑定枚举
  updateInterfaceBindingEnumPackage: '/gateway/api/interface/enum_package/update/',
  getEnumPackageExport: '/gateway/api/enum_package/export/',
};
// 接口文档 https://bytedance.feishu.cn/docs/doccnsFPnmGyTDAqYwMLpbZt4Sh#
// https://bytedance.feishu.cn/docs/doccnFTInU9ayxxz7IqKk7ZVxLj#ou85w9
